import { getDataServiceConfig } from 'src/feature-app';

export const useGetBrand = (): 'V' | 'N' | undefined => {
	const data = getDataServiceConfig();
	const brand = data.customConfig?.brand;

	return brand;
};
